import ApiService from 'utils/ApiCalls';
import { notification } from 'antd';

const fetchAllBranches = async () => {
  try {
    const response = await ApiService.getListOfBranches();
    return response;
  } catch (error) {
    console.log('Error fetching all branches:', error);
  }
};

const fetchBranchesByEntity = async (entityData: any) => {
  try {
    const response = await ApiService.postBranchesbyEntityName(entityData);
    return response;
  } catch (error) {
    console.log('Error fetching branches by entity:', error);
  }
};

const fetchBranchbyEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postBranchByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Branch:', error);
  }
};

const insertBranches = async (branches: any) => {
  try {
    const response = await ApiService.postBranches(branches);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

export default {
  fetchAllBranches,
  fetchBranchesByEntity,
  fetchBranchbyEntityName,
  insertBranches,
};
